import { useAuthorization } from "#imports";

export default defineNuxtPlugin(async (nuxtApp) => {
  if (import.meta.env.STORYBOOK) return;
  const { isGrantedForPermission } = await useAuthorization();

  nuxtApp.vueApp.directive("is-granted", {
    async mounted(el, binding) {
      const isGranted = await isGrantedForPermission(binding.value);

      if (!isGranted) {
        el.remove();
      }
    },
  });
});
